export default __webpack_public_path__ + "7a75a04468bd5d1fe4c971083292909f.png";